<template>
    <div class="outEntre-form">
    <div class="table-container">
      <h2 class="table-container-title">出库单</h2>
      <div class="table-header-info">
        <span class="info-item"><strong>客户名称：</strong>{{formData.customerName}}</span>
        <span class="info-item"><strong>开单日期：</strong>{{parseTime(formData.createTime,'{y}/{m}/{d}')}}</span>
        <span class="info-item"><strong>单号：</strong>{{formData.number}}</span>
      </div>
      <el-table :data="formData.contentList" :span-method="handleSpan" border style="width: 100%" align="center"  class="custom-table">
        <el-table-column prop="index" label="序号" align="center" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.total">{{scope.row.categoryName}}</span>
            <span v-else-if="scope.row.remarkLast">{{scope.row.categoryName}}</span>
            <span v-else>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="categoryName" align="center" label="品名">
          <template slot-scope="scope">
            {{scope.row.categoryName}}
          </template>
        </el-table-column>
        <el-table-column prop="quantity" align="center" label="数量">
          <template slot-scope="scope">
            {{scope.row.quantity}}
          </template>
        </el-table-column>
        <el-table-column prop="units" align="center" label="单位">
          <template slot-scope="scope">
            {{scope.row.units}}
          </template>
        </el-table-column>
        <el-table-column label="价格" prop="unitPrice" align="center">
          <template slot-scope="scope">
            {{scope.row.unitPrice}}
          </template>
        </el-table-column>
        <el-table-column label="货款" prop="paymentGoods" align="center">
          <template slot-scope="scope">
            {{scope.row.paymentGoods}}
          </template>
        </el-table-column>
        <el-table-column label="备注" header-align="center" align="left" width="400">
          <template slot-scope="scope">
            <!-- 使用 v-html 指令渲染富文本内容 -->
            <div v-html="replaceNewlines(scope.row.remark)"></div>
          </template>
        </el-table-column>
      </el-table>
       <div class="table-footer-info">
        <span class="footer-info-item"><strong>制单：</strong></span>
        <span class="footer-info-item"><strong>财务：</strong></span>
        <span class="footer-info-item"><strong>仓库：</strong></span>
        <span class="footer-info-item"><strong>客户签名：</strong></span>
      </div>
    </div>
    </div>
</template>
<script>
  import { outEntrepotDetailById} from "@/api/api.js";//附加单据
  export default {
    name: "OutEntrepot",
    props: {
        outEntrepotId: {
            type: [Number,String]
        }
    },
    data() {
        return {
            formData:{},
        };
    },

    methods: {
      initData(){
        outEntrepotDetailById({id: this.outEntrepotId}).then(res=>{
          this.formData = res.data.data;
          let amountRow={total: true,categoryName:'合计',quantity:res.data.data.total,remark:res.data.data.noticeRemark}
          let remarkRow={remarkLast: true,categoryName:'备注',remark:res.data.data.remark}
          this.formData.contentList.push(amountRow,remarkRow)
        });
      },
      handleSpan({ row, column, rowIndex, columnIndex }) {
        if (row.total) {
          if (columnIndex === 0) {
            return { rowspan: 1, colspan: 2 }; // 合并序号、品名
          } else if (columnIndex < 2) {
            return { rowspan: 1, colspan: 0 }; // 隐藏品名
          } else if (columnIndex === 2) {
            return { rowspan: 1, colspan: 1 }; // 显示数量列
          } else if (columnIndex === 6) {
            return { rowspan: 1, colspan: 4 }; // 显示1行4列
          }else {
            return { rowspan: 1, colspan: 0 }; // 隐藏其他列
          }
        } else if (row.remarkLast) {
          if (columnIndex === 0) {
            return { rowspan: 1, colspan: 1 };
          } else if(columnIndex === 6) {
            return { rowspan: 1, colspan: 6 }; // 备注内容跨后七列
          }else{
            return { rowspan: 1, colspan: 0 }; // 隐藏其他列
          }
        }
      },
      // 将 \n 替换为 <br> 标签的方法
      replaceNewlines(text) {
        if (text) {
          return text.replace(/\n/g, "<br>");
        }
        return "";
      },

    },
    watch:{
        outEntrepotId(){
            this.initData();
        }
    },
    created() {},
    mounted() {
      this.initData()
    },
    
  };
</script>
<style scoped lang="less">
    .outEntre-form {
        width: 80%;
        padding: 20px;
        background-color: #fff;
        border-radius: 4px;
        border: 1px solid #000;
        margin-top: 20px;
    }
  .table-container {
    width: 100%;
    max-width: 1300px; 
    .table-container-title{
      text-align: center;
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 40px;
    }
    .table-header-info {
      margin-bottom: 6px;
      display: flex;
      gap: 100px; /* 调整信息项之间的间距 */
    }
    .table-footer-info {
      margin-top: 6px;
      display: flex;
      gap: 120px; 
    }
    .info-item {
      font-size: 18px;
    }
    .footer-info-item{
      font-size: 15px;
    }
    .el-table {
      text-align: center;
      td, th {
        text-align: center !important;
      }
    }
    .el-form-item span {
      display: inline-block;
      padding-top: 6px;
    }
    .filter-actions {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 20px;
    }
    /deep/ .custom-table{
      border: 1px solid black;
      /* 表头样式 */
      .el-table__header {
        background-color: black;
        color: white;
      }
      /* 表格主体样式 */
      .el-table__body {
        background-color: white;
      }
      /* 单元格边框样式 */
      .el-table__body-wrapper td {
        border-color: black !important;
      }
      .el-table__header-wrapper th {
        border-color: black !important;
      }
      /* 单元格之间的分隔线 */
      .el-table__body-wrapper tr td {
        border-right: 1px solid black;
      }
       .el-table__body-wrapper tr td:last-child {
        border-right: none;
      }
      /* 表头分隔线样式 */
      .el-table__header-wrapper th.is-leaf {
        border-bottom: 1px solid black;
      }
      /* 表格底部边框样式 */
      .el-table__body-wrapper tr:last-child td {
        border-bottom: 1px solid black;
      }

    }
  }

  /* 可添加样式控制富文本内容的显示 */
  .el-table .el-table__cell div[v-html] {
    word-break: break-word; /* 允许长单词换行 */
  }
  /* 设置表头字体大小和粗细 */
  /deep/ .el-table thead th {
    font-size: 16px; 
    font-weight: 600; 
  }
  /* 设置表格内容字体大小和粗细 */
  /deep/ .el-table tbody td {
    font-size: 15px; 
    font-weight: 500; 
  }
  
</style>


